const app = {
  routerName: {
    home: 'home',
    settings: 'settings',
    catalog: 'catalog',
    order: 'order',
    checkout: 'checkout',
    loyalty: 'loyalty',
    pointsHistory: 'pointsHistory',
    maintenance: 'maintenance',
    mission: 'mission'
  }
}
const pages = {
  settings: '/settings',
  checkout: '/checkout',
  loyalty: '/loyalty',
  pointsHistory: '/pointsHistory',
  maintenance: '/maintenance',
  mission: '/mission'
}

const api = {
  auth: {
    login: '/omg-member/api/login',
    logout: '/omg-member/api/login/destroy',
    signup: '/omg-member/api/login/sign-up',
    userDetails: '/omg-member/api/login/user',
    verifyEmailWithId: '/omg-member/api/login/verify-mail',
    forgotPassword: '/omg-member/api/login/forgot-password',
    resetPassword: '/omg-member/api/login/reset-password',
    verifyPasswordWithId: '/omg-member/api/login/verify-password-link',
    sendVerificationEmail: '/omg-member/api/login/send-verification-mail',
    sessionUpdate: '/omg-member/api/session/update'
  },
  registration: {
    getAccountRegistrationSummary: '/omg-member/api/register/getAccountRegistrationSummary',
    postRegisterData: '/omg-member/api/register',
    fileUpload: '/omg-member/api/register/upload',
    getSectionTrackingDetails: '/omg-member/api/register/getSectionTrackingDetails',
    completeRegistrationProcess: '/omg-member/api/register/updateLegalReview'
  },
  product: {
    getAllCategories: '/omg-product/api/catalogue/getAllValue',
    getAllProducts: '/omg-product/api/product/getAllValue',
    getProductDetails: '/omg-product/api/product/getValue'
  },
  cart: {
    addToCart: '/omg-cart/api/cart/addToCart',
    getCartItems: '/omg-cart/api/cart/getCartItems',
    createQuotation: '/omg-cart/api/quotation/createQuotation',
    getAvailableTermsOfPayment: '/omg-cart/api/cart/getAvailableTermsOfPayment',
    dealerPurchaseReport: '/omg-cart/api/cart/download/dealerPurchaseReport'
  },
  order: {
    getOrderList: '/omg-cart/api/quotation/getQuotationHistory',
    getOrderDetail: '/omg-cart/api/quotation/getQuotationDetails',
    processQuotation: '/omg-cart/api/quotation/processQuotation',
    createOtp: '/omg-cart/api/otp/create',
    validateOtp: '/omg-cart/api/otp/verify'
  },
  rewards: {
    scannedProductList: '/omg-engagement/api/reward-point/scanned-products-list',
    addScannedProduct: '/omg-engagement/api/reward-point/scan',
    downloadProducts: '/omg-engagement/api/reward-point/download-scanned-info',
    uploadProducts: '/omg-engagement/api/reward-point/upload-scanned-info-pwa',
    getEngagementInfo: '/omg-engagement/api/engagement/getEngagementInfo',
    pointsHistory: '/omg-engagement/api/loyalty/history',
    getScannedProductDetail: '/omg-engagement/api/reward-point/get-scanned-product',
    uploadInvoice: '/omg-engagement/api/cashback/claim-cashback',
    listGift: '/omg-engagement/api/gift/findActiveGifts',
    redeemGift: '/omg-engagement/api/giftRedemption/redeem',
    getRedeemedGiftDetails: '/omg-engagement/api/giftRedemption/giftDetail',
    getRedeemedHistory: '/omg-engagement/api/giftRedemption/history'
  },
  cmsConfig: {
    getConfig: '/config/get/',
    getServiceAndPromotion: '/backend/content/pages/omg/sections?display=normal'
  },
  banner: {
    getAllBanners: '/omg-engagement/api/banner/getAllBanners'
  },
  mission: {
    getMissionDetail: '/omg-engagement/api/mission/getDealerDetails'
  },
  nps: {
    saveNpsFeedback: '/omg-engagement/api/feedback/saveNps',
    cancelNpsFeedback: '/omg-engagement/api/feedback/cancelNps'
  }
}

export { app, pages, api }
